<template>
  <div class="grid grid-cols-6 gap-6">
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="year" class="block text-sm font-medium text-gray-700">Año</label>
      <input type="number" step="1" min="1920" id="year"
             class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
             v-model="formMasivo.year">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="mes" class="block text-sm font-medium text-gray-700">Mes</label>
      <select class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              v-model="formMasivo.mes">
        <option value="" selected>Seleccione un mes...</option>
        <option v-for="(nameMonth, key, index) in monthNames()" :value="parseInt(key)+1" :key="'B'+index">
          {{ nameMonth }}
        </option>
      </select>
    </div>
    <template v-if="formMasivo.year && formMasivo.mes">
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="banco_id" class="block text-sm font-medium text-gray-700">Nombre del banco</label>
        <select id="banco_id"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                :value="formBancoTasaEfectivaAnual.banco_id"
                @change="(idBancoNew)=>$emit('updateBancoId', {'banco_id': idBancoNew.target.value})">
          <option value="" selected>Seleccione un banco...</option>
          <option v-for="(cuentaBancaria, index) of arregloBancos" :key="'C'+index" :value="cuentaBancaria.banco.id">{{
              cuentaBancaria.banco.nombre_banco
            }}
          </option>
        </select>
      </div>
      <template v-if="formBancoTasaEfectivaAnual.banco_id">
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="cuenta_bancaria_id" class="block text-sm font-medium text-gray-700">Cuenta bancaria</label>
          <select id="cuenta_bancaria_id"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  v-model="formMasivo.cuenta_bancaria_id">
            <option value="" selected>Seleccione una cuenta bancaria...</option>
            <option v-for="(cuentaBancaria, index) of cuentasBancarias.filter(cuentaBancaria => cuentaBancaria.banco_id === formBancoTasaEfectivaAnual.banco_id)" :key="'D'+index" :value="cuentaBancaria.id">
              {{
                cuentaBancaria.cuenta_bancaria
              }}
            </option>
          </select>
        </div>
        <template v-if="formMasivo.cuenta_bancaria_id">
          <div class="col-span-6 sm:col-span-3 lg:col-span-2">
            <label for="banco_tasa_efectiva_anual_id" class="block text-sm font-medium text-gray-700">Tasa Efectiva
              Anual Vigente</label>
            <input type="text" id="banco_tasa_efectiva_anual_id"
                    :value="tasaEA?'%'+tasaEA.tasa_efectiva_anual:'No hay una Tasa E.A. vigente activa'" disabled
                    class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
          </div>
        </template>
      </template>
    </template>
  </div>
  <div class="mt-3">
    <template v-if="!(formMasivo.year && formMasivo.mes)">
      <p class="text-left"><b>IMPORTANTE: </b></p>
      <p class="text-left">- Debe ingresar el mes y el año para seleccionar el banco correspondiente
        al extracto bancario.
      </p>
    </template>
    <template v-else>
      <template v-if="!formBancoTasaEfectivaAnual.banco_id&&cuentasBancarias.length">
        <p class="text-left"><b>IMPORTANTE: </b></p>
        <p class="text-left">- Debe seleccionar un banco para cargar la <b>Tasa Efectiva
          Anual</b></p>
      </template>
      <template v-else-if="!cuentasBancarias.length">
        <p class="text-left"><b><span class="text-yellow-500">ADVERTENCIA: </span></b></p>
        <p class="text-left">- No hay bancos que tengan una <b>Tasa
          E.A.</b> registrados para el mes y año
          indicado. <b>Es necesario registrarlo para continuar.</b>
        </p>
      </template>
    </template>
  </div>
</template>

<script>
import {monthNames} from "@/common/constants";
import { watch, ref } from "vue";

export default {
  name: 'ExtractosBancariosCrearActualizarComponent',
  methods: {
    monthNames() {
      return monthNames
    }
  },
  props: ['authToken', 'view', 'loadData', 'formBancoTasaEfectivaAnual', 'arregloBancos', 'cuentasBancarias', 'tasaEA', 'listarBancosPorMesYear', 'listarCuentasBancariasPorMesYear', 'listarTasasEA', 'customUpdateValueData'],
  emits: ['updateValues', 'updateBancoId'],
  async setup(props, {emit}) {
    const formMasivo = ref({
      tasa_e_a_id: '',
      cuenta_bancaria_id: '',
      year: '',
      mes: '',
    });
    watch(() => ({...formMasivo.value}), async (newFormMasivo, oldFormMasivo) => {
      if (newFormMasivo.mes && newFormMasivo.year && (oldFormMasivo.mes !== newFormMasivo.mes || oldFormMasivo.year !== newFormMasivo.year)){
        formMasivo.value.tasa_e_a_id = '';
        await props.listarCuentasBancariasPorMesYear(props.authToken, 1, 'created_at', 'ASC', '', '', `table.estado = 1, table.year = ${newFormMasivo.year}, table.mes = ${newFormMasivo.mes}`, false);
      }
    });
    watch(() => formMasivo.value.cuenta_bancaria_id, async (newCuentaBancariaId) => {
      if(newCuentaBancariaId)
      await props.listarTasasEA(props.authToken, 1, 'created_at', 'ASC', '', '', `table.cuenta_bancaria_id=${newCuentaBancariaId}, table.estado = 1, table.year = ${formMasivo.value.year}, table.mes = ${formMasivo.value.mes}`, false);
      emit('updateValues', {'banco_tasa_efectiva_anual_id': props.tasaEA.id, 'year': formMasivo.value.year, 'mes': formMasivo.value.mes})
    })
    watch(() => props.formBancoTasaEfectivaAnual.banco_id, async () => {
      formMasivo.value.cuenta_bancaria_id = '';
    });
    return {
      formMasivo
    }
  }
}
</script>